import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { capitalizeFirstLetter, truncateText } from "../../helpers";
import { MdOutlineChevronRight } from "react-icons/md";
import moment from "moment";
import Tooltip from "../Tooltip";

const Table = ({ setSelectedData, apiData, setIsComplaint }) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);

    useEffect(() => {
        setCurrentPage(0);
    }, [apiData]);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const complaint = (item) => {
        setIsComplaint(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        return (
            // <div className="flex gap-4 ">
            //     <button
            //         onClick={() => complaint(item)}
            //         className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
            //     >
            //         {/* Edit */}
            //         <MdOutlineChevronRight className="text-gray-300" size={24} />
            //     </button>
            // </div>
            <Tooltip label="View complain details">
                <button
                    onClick={() => complaint(item)}
                    className="text-gray-400 hover:text-gray-700 transition"
                >
                    <MdOutlineChevronRight size={22} />
                </button>
            </Tooltip>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                raisedOn: (
                    <span className="text-gray-600 text-sm">
                        {moment(item.createdAt).format("DD, MMM YY hh:mm A")}
                    </span>
                ),
                title: getComplaint(item),
                name: getName(item),
                status: getStatus(item),
                action: ActionBtns(item),
                property: getProperty(item),
                description: item.description,
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    // const getProperty = (item) => {
    //     return (
    //         <>
    //             <span className="text-gray-600 text-sm">
    //                 {item.propertyName}
    //             </span>
    //             {/* <span
    //                 className={`bg-neutral-100 text-gray-600 px-3 py-1 rounded-md text-sm`}
    //             >
    //                 {"#" + item?.roomNum + ", " + item?.floor}
    //             </span> */}
    //         </>
    //     );
    // };

    const getProperty = (item) => {
        const name = capitalizeFirstLetter(item?.propertyName || '--');
        return (
            <span className="text-gray-600 text-sm block max-w-[160px] break-words line-clamp-2">
                {truncateText(name, 35)}{" "}
            </span>
        );
    };

    const getComplaint = (item) => {
        return (
            <div className="flex flex-col gap-1">
                <span className="text-gray-600 text-sm">{item?.title}</span>
                <span
                    className="text-gray-400 text-sm"
                >
                    <Tooltip label={item.description}>
                        {truncateText(item.description, 20)}
                    </Tooltip>
                </span>

            </div>
        );
    };

    const getName = (item) => {
        return (
            <UserImageWrapper>
                <UserImage
                    src={Images.Avatar}
                    alt={`Avatar for ${item.raisedByName}`}
                />
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm">
                        {item?.raisedByName?.charAt(0).toUpperCase() +
                            item?.raisedByName?.slice(1)}
                        {""}
                        {/* <span className="text-xs bg-zinc-100 text-zinc-500 px-1 py-0.5 rounded-sm">
                  {getTenantGender(item?.gender)}
                </span> */}
                    </span>
                    <span className="text-gray-400 text-xs">#{item.raisedByMobile}</span>
                </div>
            </UserImageWrapper>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const StatusCell = ({ status, staffName }) => (
        <div>
            <span className={`badge badge-${status.toLowerCase()}`}>
                {status}
            </span>
            <div className="text-xs text-gray-500">
                Assigned: {staffName || 'Unassigned'}
            </div>
        </div>
    );

    const getStatus = (item) => {
        if (item.status === 1) {
            return <div>
                <span className={`text-sm font-semibold text-yellow-500`}>
                    {"Pending"}
                </span>
                <div className="text-xs text-gray-500">
                    {item.staffName ? truncateText(item.staffName, 15) : 'Unassigned'}
                </div>
            </div>;
        } else if (item.status === 2) {
            return <div>
                <span className={`text-sm font-semibold text-blue-500`}>
                    {"Assigned"}
                </span>
                <div className="text-xs text-gray-500">
                    {item.staffName ? truncateText(item.staffName, 15) : 'Unassigned'}
                </div>
            </div>;
        } else if (item.status === 3) {
            return <div>
                <span className={`text-sm font-semibold text-green-500`}>
                    {"Resolved"}
                </span>
                <div className="text-xs text-gray-500">
                    {item.staffName ? truncateText(item.staffName, 15) : 'Unassigned'}
                </div>
            </div>;
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Raised By",
                    accessor: "name",
                },
                {
                    Header: "Property",
                    accessor: "bed",
                },
            ];
        }
        return [
            {
                Header: "Raised By",
                accessor: "name",
            },
            {
                Header: "Property",
                accessor: "property",
            },
            {
                Header: "Complaint",
                accessor: "title",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Raised On",
                accessor: "raisedOn",
            },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Complaint:</strong> {data[rowIndex].title}
                                                </li>
                                                <li>
                                                    <strong>Description:</strong>{" "}
                                                    {data[rowIndex].description}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Status:</strong> {data[rowIndex].status}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Raised On:</strong> {data[rowIndex].raisedOn}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative cursor-pointer`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-9 h-9 rounded-full `;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
// const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const Pending = tw.div`bg-yellow-50 text-yellow-500 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Inprogress = tw.div`bg-yellow-50 text-yellow-500 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Resolved = tw.div`bg-green-50 text-green-500 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;

const Assigned = tw.div`bg-blue-50 text-blue-500 text-xs border-blue-100 border w-24 h-7 flex items-center justify-center rounded-full`;
const New = tw.div`bg-purple-50 text-purple-500 text-xs border-purple-100 border w-24 h-7 flex items-center justify-center rounded-lg`;

export default Table;
